import { trackEvent } from "../utils/track-event";
import type {
  TrackingEvent,
  TrackingEventResponse,
  TrackPromotionProps,
} from "../utils/types";

type ViewedPromotionEventProps = TrackPromotionProps;

export type ViewedPromotionEvent = TrackingEvent<
  "Viewed Promotion",
  {
    promo_id?: string;
    promo_creative?: string;
    promo_position?: string;
    promo_type?: string;
    promo_path?: string;
    shop_type?: string;
    gated: boolean;
    promo_display_type?: string;
  }
>;

export async function trackViewedPromotionEvent({
  id,
  name,
  creative,
  position,
  promotionType,
  path,
  shopType,
  promoDisplayType,
  gated = false,
}: ViewedPromotionEventProps): TrackingEventResponse {
  return await trackEvent("Viewed Promotion", {
    props: {
      promo_id: id || name,
      promo_creative: creative,
      promo_position: position,
      promo_type: promotionType,
      promo_display_type: promoDisplayType?.toLowerCase(),
      promo_path: path,
      shop_type: shopType,
      gated,
    },
    withRequestSource: true,
  });
}
